import { type WorkoutSetType } from "api-client";

export interface WorkoutSetTypeOption {
  type: WorkoutSetType | null;
  letter: string;
  labelKey:
    | "workoutItemSets.setType.regular"
    | "workoutItemSets.setType.warmUp"
    | "workoutItemSets.setType.dropSet"
    | "workoutItemSets.setType.failure";
  className: string;
}

const WORKOUT_SET_TYPE_OPTION_BY_KEY: Record<
  WorkoutSetType | "REGULAR",
  WorkoutSetTypeOption
> = {
  REGULAR: {
    type: null,
    letter: "R",
    labelKey: "workoutItemSets.setType.regular",
    className: "text-amber-500",
  },
  WARM_UP: {
    type: "WARM_UP",
    letter: "W",
    labelKey: "workoutItemSets.setType.warmUp",
    className: "text-slate-400",
  },
  DROP_SET: {
    type: "DROP_SET",
    letter: "D",
    labelKey: "workoutItemSets.setType.dropSet",
    className: "text-blue-500",
  },
  FAILURE: {
    type: "FAILURE",
    letter: "F",
    labelKey: "workoutItemSets.setType.failure",
    className: "text-red-500",
  },
};

export const WORKOUT_SET_TYPE_OPTIONS = Object.values(
  WORKOUT_SET_TYPE_OPTION_BY_KEY,
);

export function getWorkoutSetTypeOption(
  type: WorkoutSetType | null,
): WorkoutSetTypeOption {
  return WORKOUT_SET_TYPE_OPTION_BY_KEY[type ?? "REGULAR"];
}
